import { WMDescriptiveCodesLookupLayout } from '../../../../common/lookups/Layouts/WMLayouts';

/**
 * The "Code 1..5" user-defined code lookups the WM Data Profile screens share. Each code is a WMCODES
 * descriptive code restricted to its own code type (the CodeType property on edtUserDefinedCode1..5
 * in the screen's DFM), so the lists are separate and each field gets its own lookup layout.
 *
 * These render as a searchable SelectBox plus the magnifier popup grid. That combination is what
 * omitting `lookupDisplayMode` buys: DynamicFromLookup renders a bare TextBox with only the popup
 * button when it is set to "grid". Do not add lookupDisplayMode here.
 *
 * forSearch: the search panel keys are camelCase (`userDefinedCode1`) and hidden, matching the
 * listing grid where the codes sit behind the column chooser; the form keys are the ALL-CAPS
 * dynamic-form names (`USERDEFINEDCODE1`) and carry the column width.
 */
export const buildUserDefinedCodeFields = ({ codeTypes, gridKey, tableName, maxLength, forSearch }) =>
    codeTypes.map((codeType, index) => {
        const number = index + 1;
        const field = {
            "name": forSearch ? `userDefinedCode${number}` : `USERDEFINEDCODE${number}`,
            "localizedField": `USERDEFINEDCODE_${number}`,
            "tableName": tableName,
            "label": `Code ${number}`,
            "type": "lookup",
            "layout": WMDescriptiveCodesLookupLayout(codeType, gridKey),
            "required": false,
            "visible": !forSearch,
            "isLabelChanged": false,
        };

        return forSearch ? field : { ...field, "maxLength": maxLength };
    });
